<template>
  <main class="content">
    <headerCustom :name="translation.NAME" :logo="translation.LOGO" :lang="language" @changeLang="changeLanguage"/>
    <section class="container-fluid">
      <b-container fluid="xl" class="form">
        <b-row>
          <b-col cols="12" md="6" class="p-0 d-none d-md-block">
            <div class="form__description" :style="'background-image: url('+translation.IMAGE+');'">
              <h3 v-if="translation[language].motivation !== undefined" v-html="translation[language].motivation"></h3>
              <div class="note">
                <!--<h2>{{ options[option].title }}</h2>
                <p>{{ options[option].text }}</p>
                <div class="options">
                  <button
                    :class="option == 0 ? 'active' : ''"
                    v-on:click="changeOption(0)"
                  ></button>
                  <button
                    :class="option == 1 ? 'active' : ''"
                    v-on:click="changeOption(1)"
                  ></button>
                  <button
                    :class="option == 2 ? 'active' : ''"
                    v-on:click="changeOption(2)"
                  ></button>
                  <button
                    :class="option == 3 ? 'active' : ''"
                    v-on:click="changeOption(3)"
                  ></button>
                </div>-->
              </div>
            </div>
          </b-col>
          <b-col cols="12" md="6" class="p-0 bg-white">
            <div class="form__content">
              <h1>{{title[language]}}</h1>
              <div class="line"></div>
              <p>
                <h2>{{translation[language].title}}</h2>
                <p v-html="translation[language].description"></p>
              </p>
              <div style="margin:auto;width: 270px;text-align: center;">
                <ButtonGoogleLogin id="google-button" v-if="translation.AUTH['GOOGLE']" type="SIGNUP" :lang="language" variant="secondary" />
                <b-tooltip target="google-button" variant="warning">
                  {{tooltip.GOOGLE[language]}}
                </b-tooltip>
                <ButtonMicrosoftLogin v-if="translation.AUTH['MICROSOFT']" type="SIGNUP" :lang="language" variant="secondary" class="mt-2"/>
                <ButtonLinkedInLogin v-if="translation.AUTH['LINKEDIN']" type="SIGNUP" :lang="language" variant="secondary" class="mt-2"/>
                <ButtonEmailVerification id="otp-button" v-if="translation.AUTH['OTP']" type="SIGNUP" :lang="language"  variant="secondary" :channel="2" class="mt-2"/>
                <b-tooltip target="otp-button" variant="warning" placement="bottom">
                  {{tooltip.OTP[language]}}
                </b-tooltip>
              </div>
              <span>{{policy[language]}}</span>
              <div class="line--2"></div>
              <a href="/login">
                <span v-html="motivation_access_account[language]"></span>
                {{access_account[language]}}
              </a>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <b-container fluid>
                <b-row>
                  <b-col>
                    <div class="content__options">
                      <a
                        class="content__link"
                        href="https://systemico.net/terms"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Terms of Use</a
                      >
                      <a
                        class="content__link"
                        href="https://systemico.net/politics"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Privacy Policy</a
                      >
                      <a
                        class="content__link"
                        href="https://systemico.net/advice"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Privacy Advice</a
                      >
                    </div>
                  </b-col>
                </b-row>
              </b-container>
    </section>
    <footerCustom />
  </main>
</template>

<script>
import headerCustom from "../components/header.vue";
import footerCustom from "../components/footer.vue";
import ButtonEmailVerification from "@/packages/systemico.ui/components/buttons/ButtonEmailVerification.vue";
import ButtonGoogleLogin from "@/packages/systemico.ui/components/buttons/ButtonGoogleLogin.vue";
import ButtonLinkedInLogin from "@/packages/systemico.ui/components/buttons/ButtonLinkedInLogin.vue";
import FooterSystemicoComponent from "@/packages/systemico.ui/components/footers/FooterSystemicoComponent.vue";
import ButtonMicrosoftLogin from "@/packages/systemico.ui/components/buttons/ButtonMicrosoftLogin.vue";
import ButtonComponent from "@/packages/systemico.ui/components/buttons/ButtonComponent.vue";
import json from "../../../../lang/signup.json";
export default {
  name: "SignupView",
  components: {
    ButtonComponent,
    ButtonMicrosoftLogin,
    FooterSystemicoComponent,
    ButtonLinkedInLogin,
    ButtonGoogleLogin,
    ButtonEmailVerification,
    headerCustom,
    footerCustom,
  },
  props: {
    lang: {
      type: String,
      default: 'EN'
    }
  },
  data: function () {
    return {
      translation: json,
      language: 'EN',
      option: 0,
      options: [
        {
          title: "Automatización de marketing.",
          text: "Envia diaria, semanal, mensual o anual notificaciones de recordatorio para adquisición o renovación de servicios.",
        },
        {
          title: "Analiza sitios web automáticamente.",
          text: "Genera bases de datos automáticas a partir de la información pública de clientes potenciales.",
        },
        {
          title: "Establece metas de impacto.",
          text: "Envia notificaciones diarias limitadas para validar horarios, aperturas y cumplimiento de tu objetivo.",
        },
        {
          title: "Define Eventos.",
          text: "Parametriza eventos para realizar acciones de llamadas, notificaciones u otros cuando un cliente cumpla una etapa de tu proceso de marketing.",
        }
      ],
      title: {
        EN: "Create your account",
        ES: "Crea tu cuenta"
      },
      policy: {
        ES: 'Cuando creas o accedes a tu cuenta aceptas nuestras políticas y términos.',
        EN: 'When you create an account you accept our policies and terms.'
      },
      motivation_access_account: {
        ES: '¿Ya tienes una cuenta?',
        EN: 'Do you have an account?'
      },
      access_account: {
        ES: 'Ingresa a tu cuenta.',
        EN: 'Access your account.'
      },
      tooltip: {
        GOOGLE: {
          ES: 'Crea tu cuenta con Google',
          EN: 'Create your account with Google'
        },
        OTP: {
          ES: 'Crea tu cuenta con cualquier email y una contraseña temporal que te enviamos a tu email.',
          EN: 'Create your account with any email and a temporary password that we send to your email.'
        }
      }
    }
  },
  mounted () {
    this.autoChangeOption()
  },
  beforeMount() {
    this.language = this.lang
  },
  methods: {
    changeOption: function (option) {
      this.option = option;
    },
    changeLanguage: function (lang) {
      this.language = lang
      this.options = this.translation[this.language].options
    },
    autoChangeOption: function () {
      setTimeout(() => {
        if (this.option == 3) {
          let option = 0
          this.option = option
          this.autoChangeOption()
        } else {
          const option = this.option + 1
          this.option = option
          this.autoChangeOption()
        }
      }, 5000);
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  min-height: 100vh;
  background-color: #f8f9fc;
  font-family: "Quicksand", sans-serif;
  &__section {
    padding: 30px 20px;
  }
  &__link {
    margin: 0;
    font-family: "Mulish", sans-serif;
    font-size: 14px;
    font-weight: normal;
    color: #4285f4;
    img {
      margin-right: 10px;
    }
  }
  &__options {
    a {
      margin: 10px 0;
      font-size:12px;
      text-align: center;
      display: block;
    }
  }
  // responsive para dispositivos de tablets en adelante
  @media (min-width: 992px) {
    &__options {
      display: flex;
      align-items: center;
      justify-content: center;
      a {
        margin: 0 10px;
        text-align: center;
        display: block;
      }
    }
  }
}

.form {
  margin: 5vh auto;
  box-shadow: 0px 3px 12px rgba(34, 37, 44, 0.16);
  border-top:1px solid #dbdee6;
  height: 70vh;
  padding: 0;
  /**border-bottom:1px solid #dbdee6;**/

  &__description {
    height: 70vh;
    min-height: 100%;
    padding: 0px;
    margin:0;
    /**background: transparent linear-gradient(41deg, #171E44 0%, #006DF0 100%) 0% 0% no-repeat padding-box;**/
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    h3{
      font-size: 1.5rem;
      color:#fefefe;
      font-weight:lighter;
      background: #222222;
      opacity: 0.8;
      padding-left:1.5rem;
      padding-right:0.5rem;
      padding-top:0.5rem;
      padding-bottom:0.5rem;
      border-radius: 0px 0px 20px 0px;
      margin-right:5rem;
      border-right: 3px solid #fefefe;
      border-bottom: 3px solid #fefefe;
    }
    .note{
      border-radius:5px;
      margin:20px;
      display: none;
      h2 {
        /**margin: 0 0 0px;**/
        font-family: "Quicksand", sans-serif;
        font-size: 18px;
        font-weight: 700;
        color: #222222;
        text-align: center;
        padding: 5px;
        border-bottom: 2px solid #aaaaaa;
      }

      p {
        font-family: "Quicksand", sans-serif;
        font-size: 16px;
        font-weight: normal;
        color: #444444;
        text-align: center;
        height: 60px;
        margin:0;
        padding: 5px;
      }

      .options {
        margin: 0;
        padding: 5px;
        display: flex;
        align-items: center;
        justify-content: center;

        button {
          width: 7px;
          min-width: 7px;
          max-width: 7px;
          height: 7px;
          margin: 0 0.5rem;
          padding: 0;
          border: 1px solid #aaaaaa;
          border-radius: 50%;
          background: transparent;

          &.active {
            background-color: #0b1c98;
          }
        }
      }
    }
  }

  &__content {
    padding: 20px;
    border-radius: 0 0 5px 5px;

    & > h1 {
      margin: 0 0 10px;
      font-size: 1rem;
      font-weight: bold;
      color: #aaaaaa;
      text-align: center;
    }

    & > h2 {
      margin: 0 0 20px;
      font-size: 2rem;
      font-weight: bold;
      color: #4d556e;
      text-align: center;
    }

    .line {
      width: 86px;
      height: 4px;
      margin: 0 auto 30px;
      border-radius: 4px;
      background-color: #dbdee6;
      display: block;
    }

    & > p {
      margin: 0 0 20px;
      font-family: "Mulish", sans-serif;
      font-size: 16px;
      font-weight: normal;
      color: #4d556e;
      text-align: center;
      display: block;
    }

    .line--2 {
      width: 100%;
      height: 2px;
      margin: 0 auto 20px;
      border-radius: 4px;
      background-color: #dbdee6;
      display: block;
    }

    & > span {
      margin: 10px 0 10px;
      font-family: "Mulish", sans-serif;
      font-size: 12px;
      font-weight: lighter;
      color: #4d556e;
      text-align: center;
      display: block;
    }

    & > a {
      margin: 0;
      font-family: "Mulish", sans-serif;
      font-size: 14px;
      font-weight: normal;
      color: #4285f4;
      text-align: center;
      display: block;

      span {
        font-weight: lighter;
        color: #4d556e;
      }
    }
  }

  // responsive para dispositivos de tablets en adelante
  @media (min-width: 992px) {
    border-radius: 5px;
    overflow: hidden;
    &__content {
      padding: 40px 50px;
      border-radius: 0;
    }
  }
}
</style>
